document.addEventListener('turbo:load', function () {
  var calendar;

  // Select the calendar pane element
  var calendarPaneEl = document.querySelector('[id^="calendarPane-"]'); // Use a more flexible selector
  if (!calendarPaneEl) {
    console.error('Calendar pane element not found');
    return;
  }

  // Get the dance style id and slug from data attributes
  var danceStyleId = calendarPaneEl.dataset.dancestyleId;
  var danceStyleSlug = calendarPaneEl.dataset.dancestyleSlug;

  if (!danceStyleId || !danceStyleSlug) {
    console.error('Dance style ID or slug not found');
    return;
  }

  // Now use the dance style id and slug in your selectors and URLs
  var calendarEl = document.getElementById('calendar');
  var calendarTabEl = document.getElementById(`calendar-tab-${danceStyleId}`);

  calendar = new FullCalendar.Calendar(calendarEl, {
    headerToolbar: {
      right: 'prev,next today',
      center: 'title',
      left: 'dayGridMonth,timeGridWeek,timeGridDay',
    },
    initialView: 'dayGridMonth',
    events: '/dance_styles/' + danceStyleSlug + '/events',
    eventColor: '#ffdd9c',
    height: 'auto',
    timeZone: '<%= @event.timezone %>', // If @event is available, otherwise handle it too
    eventContent: function (info) {
      let titleElement = document.createElement('div');
      titleElement.classList.add('fc-event-title');
      titleElement.innerHTML = `
                <span class="event-title-text">${info.event.title}</span>
            `;
      return { domNodes: [titleElement] };
    },
    eventDidMount: function (info) {
      let eventEl = info.el;
      eventEl.style.height = 'auto';
      eventEl.style.whiteSpace = 'normal';
      eventEl.style.minHeight = '30px';
    },
    eventClick: function (info) {
      info.jsEvent.preventDefault();
      info.jsEvent.stopPropagation();
      updateModalWithContent(info.event.url, 'event');
    },
  });

  calendar.render();

  // Event listeners for click on calendar tab
  document.body.addEventListener('click', function (e) {
    if (e.target && e.target.id === `calendar-tab-${danceStyleId}`) {
      setTimeout(function () {
        if (calendar) {
          calendar.updateSize();
        } else {
          console.error('Calendar is not initialized');
        }
      }, 100);
    }
  });
});
